import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Container from '../../components/Container';
import { constants } from '../../devUtils';

const BreadCrumb = styled.section`
  padding:20px 0px 5px 0px;
  visibility: hidden;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    display:none;
    };
  ul{
    list-style:none;
    margin:0px;
    padding:0px;
    li{
      display: inline-block;
      a{
        display:block;
        text-decoration:none;
        color: ${({ theme }) => theme.secondaryColor};
        margin-right:10px;
        &:after{
          content:'>';
          margin-left:10px;
        }
      }
      &:last-child{
        a{
          font-weight:bold;
          &:after{
            display:none;
          }
        }
      }
    }
  }
`;

function Breadcrumb() {
  return (
    <BreadCrumb>
      <Container>
        <ul>
          <li><Link to={constants.LINK_HOME}>Home</Link></li>
          {/* <li><a href="#/">Restaurant Deals</a></li> */}
        </ul>
      </Container>
    </BreadCrumb>
  );
}

Breadcrumb.propTypes = {

};

export default Breadcrumb;



// WEBPACK FOOTER //
// client/components/Breadcrumb/index.js